
export const all_routes = {
  // Auth
  signin: "/signin",

  // Errors
  error404: "/error-404",
  error500: "/error-500",
  comingsoon: "/coming-soon",
  undermaintenance: "/under-maintenance",

  // Dashboard
  dashboard: "/admin-dashboard",
  salesdashboard: "/sales-dashboard",

  // user
  profile: "/overview/profile",

  // user management 
  users: "/users",


  // POS
  allmodule: "/overview/modules",

  // Products
  productlist: "/product-list",
  addproduct: "/add-product",
  units: "/units",
  expiredproduct: "/expired-products",
  lowstock: "/low-stocks",
  categorylist: "/category-list",
  stockmove: "/move-stock",
 

  // stock 
  storelist: "/store-list",
  managestock: "/manage-stocks",
  stockadjustment: "/stock-adjustment",
  stocktransfer: "/stock-transfer",
};
